import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import { paths } from "../../config/paths";

export function Home() {
  const navigate = useNavigate();

  return (
    <div
      className="relative flex flex-col justify-center items-center p-[16px] gap-y-32 w-full h-full min-h-full bg-cover bg-center overflow-hidden"
      style={{
        backgroundImage: "url('/logo.jpg')",
      }}
    >
      <div className="flex items-center gap-10 flex-col rounded-lg">
        <img
          src="/logo_name.png"
          alt="Christian Louboutin Beaute"
          className="w-[400px] object-contain"
        />
      </div>
      <div className="flex flex-col gap-8 max-w-[800px] w-full text-xl">
        <Button
          onClick={() => navigate(paths.beautyProfiler.path)}
          className="text-xl p-8 hover:bg-white/10 hover:text-white"
        >
          Beauty Profiler
        </Button>
        <Button
          onClick={() => navigate(paths.looksGallery.path)}
          className="text-xl p-8 hover:bg-white/10 hover:text-white"
        >
          Galerie des Looks
        </Button>
        <Button
          onClick={() => navigate(paths.fragranceProfiler.path)}
          className="text-xl p-8 hover:bg-white/10 hover:text-white"
        >
          Fragrance Profiler
        </Button>
      </div>
    </div>
  );
}
